<template>
  <div class="dialog">
    <span class="cls" @click="oth_showTodoEdit(false)"></span>
    <div class="paper">
      <div class="header">
        <span class="counter">{{ currentIndex + 1 }} / {{ images.length }}</span>
        <span class="close-btn" @click="oth_showTodoEdit(false)">
          <i class="ph ph-x"></i>
        </span>
      </div>

      <div class="swiper-wrap">
        <swiper
          :modules="modules"
          :slides-per-view="1"
          :pagination="{ clickable: true }"
          :navigation="true"
          :zoom="true"
          :initial-slide="startIndex"
          @slideChange="onSlideChange"
        >
          <swiper-slide v-for="(img, idx) in images" :key="idx">
            <div class="swiper-zoom-container">
              <img :src="img" alt="" />
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue"
import { Swiper, SwiperSlide, Navigation, Pagination, Zoom } from 'swiper/vue'
import "swiper/swiper-bundle.min.css";

export default {
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    oth_showTodoEdit: Function,
    images: Array,
    startIndex: {
      type: Number,
      default: 0
    }
  },
  setup(props) {
    const modules = [Navigation, Pagination, Zoom]
    const currentIndex = ref(props.startIndex)

    const onSlideChange = (swiper) => {
      currentIndex.value = swiper.activeIndex
    }

    return {
      modules,
      currentIndex,
      onSlideChange
    }
  }
}
</script>

<style scoped>
.dialog {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.95);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.dialog > .cls {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}

.dialog > .paper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.paper > .header {
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  background: linear-gradient(to bottom, rgba(0,0,0,0.5), transparent);
}

.header > .counter {
  font-size: var(--font-size-md);
  color: #fff;
  font-weight: 500;
}

.header > .close-btn {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 50%;
  transition: background 0.2s;
}

.header > .close-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}

.header > .close-btn > i {
  font-size: var(--font-size-xl);
  color: #fff;
}

.swiper-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.swiper-wrap :deep(.swiper) {
  width: 100%;
  height: 100%;
}

.swiper-wrap :deep(.swiper-slide) {
  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper-wrap :deep(.swiper-slide img) {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

/* Navigation 버튼 스타일 */
.swiper-wrap :deep(.swiper-button-next),
.swiper-wrap :deep(.swiper-button-prev) {
  color: #fff;
}

/* Pagination 스타일 */
.swiper-wrap :deep(.swiper-pagination-bullet) {
  background: #fff;
  opacity: 0.5;
}

.swiper-wrap :deep(.swiper-pagination-bullet-active) {
  opacity: 1;
}
</style>